module.exports = __webpack_public_path__ + "static/media/2018_conf_Using_Data_to_Set_Product_Strategy.825b449c.png";